<div class="edit_race_icons">
  <button class="btn_img btn_edit" title="{{'Edit' | translate }}" (click)="openEditModal(object)" *ngIf="object.Editable"></button>
  <button class="btn_img btn_star" title="{{'Participate' | translate }}" (click)="openDevicesModal(object)" *ngIf="!object.Participate"></button>
  <button class="btn_img btn_star_orange" title="{{'Participate' | translate }}" (click)="openDevicesModal(object)" *ngIf="object.Participate"></button>
</div>
<table class="racetitle">
  <tr>
    <td><img src="/ctrl/activity/icon/{{object.Id}}?{{now}}"></td>
    <td>{{object.Name}}</td>
  </tr>
</table>

<table class="raceinfo">
  <tr><td><img src="assets/icons/contact.svg"></td><td>{{object.ContactName}}</td></tr>
  <tr><td><img src="assets/icons/calendar.svg"></td><td>{{object.From | datetime:'%0D.%0M.%0Y %0h:%0m'}} - {{object.Till | datetime:'%0D.%0M.%0Y %0h:%0m'}}</td></tr>
  <tr><td><img src="assets/icons/location.svg"></td><td>{{object.Location}}</td></tr>
  <tr><td><img src="assets/icons/link.svg"></td><td><a href="{{object.Url}}" target="_blank">{{object.Url}}</a></td></tr>
</table>
<div class="bottom_spacer"></div>
<div class="raceicons">
  <img [src]="this.typeIcon" [title]="this.typeTitle">
  <img src="assets/icons/races/distance.svg">
  <span>{{object.Distance | localizeKMeters}} {{'km'|localizeUnits}}</span>
  <a href="/Identity/Event?returnURL={{object.Name}}"><img src="assets/icons/races/broadcasting.svg" title="{{'Broadcasting' | translate }}"></a>
  <div></div>
</div>

<template #mgmtDialog>
</template>
